// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__1mwb7","Text":"styles_Text__1K8tl","Icon":"styles_Icon__3kh4N","Menu":"styles_Menu__-i-sM","Open":"styles_Open__2Kww1"};